import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectUserAvatarInfo } from '@ninety/platform/state/app-entities/users/users-state.selectors';
import { USER_AVATAR_INFO_PROVIDER, UserAvatarInfoProvider } from '@ninety/ui/core';

/**
 * Binds {@link USER_AVATAR_INFO_PROVIDER} (consumed by `TrashTableComponent` in `@ninety/ui/core`) to
 * the `selectUserAvatarInfo` store selector. The component stays free of any `@ninety/platform/state`
 * dependency so it can live in the buildable public API; this composition-root wiring is the single
 * place that depends on both the token and `platform/state`. (DEV-26530 6a)
 */
export const TRASH_TABLE_PROVIDERS: Provider[] = [
  {
    provide: USER_AVATAR_INFO_PROVIDER,
    useFactory:
      (store: Store): UserAvatarInfoProvider =>
      userId =>
        store.select(selectUserAvatarInfo(userId)),
    deps: [Store],
  },
];
